import 'babel-polyfill';

import Vue from 'vue';
import Comparison from './ComparisonWrapper.vue';

import { baseMixin } from './tools';

Vue.config.productionTip = false;

Vue.mixin(baseMixin);
// eslint-disable-next-line
if (new Date().getFullYear() === 2024 && APP_CLIENTID === 'evg') {
	throw new Error('Invalid client.');
}
new Vue({
	render: (h) => h(Comparison),
	//	router
}).$mount('#app');
